export default __webpack_public_path__ + "static/media/check.ff16bda0.jpg";